/**
 * Fixed reference date for faker.date to ensure Chromatic snapshot stability.
 * faker.seed() alone uses the current time as a reference, so refDate option must be specified with this value.
 */
export const FIXED_REF_DATE = '2024-01-15T00:00:00.000Z';
